import React from 'react'
import { DocumentsTable } from 'components/DocumentLibrary/DocumentsTable'
import { ContactCompany } from 'models/companies'
import { CompanyModal } from './CompanyModal'

interface DocumentsModalProps {
  show: boolean
  onHide: () => void
  contactCompany: ContactCompany
  forDoorProxyId?: number
  companyName?: string
}

export function DocumentsModal({
  show,
  onHide,
  contactCompany,
  forDoorProxyId,
  companyName,
}: DocumentsModalProps) {
  const TABLE_KEY = forDoorProxyId
    ? `documents-modal-door-${forDoorProxyId}`
    : `documents-modal-company-${contactCompany.id}`

  return (
    <CompanyModal
      show={show}
      onHide={onHide}
      companyName={companyName || contactCompany.name}
      modalTitle="Documents"
    >
      <div style={{ height: '60vh', display: 'flex', flexDirection: 'column' }}>
        <DocumentsTable
          tableKey={TABLE_KEY}
          filterIdentifier="DOCUMENTS_MODAL"
          tabType="company"
          forChainProxyId={contactCompany.id}
          forDoorProxyId={forDoorProxyId}
          disableUrlPagination
          disableExportButton
        />
      </div>
    </CompanyModal>
  )
}
